export default {
  path: '/kind',
  meta: {
    title: '商城',
    tab:true,
    scrollTop: 0,
    //keepAlive:true
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/kind`),
}



// WEBPACK FOOTER //
// ./src/views/Kind/router.js